import type { SpecificationStep } from '../enums';

export type SpecificationStatus = {
    step: SpecificationStep;
    wireframeExtractConfig: {
        enabled: boolean;
        remainingCount: number;
        totalCount: number;
    };
}

export const SpecificationRepository = Symbol.for('SpecificationRepository');

export interface SpecificationRepository {
    /** 获取当前步骤 */
    getSpecificationStatus(taskId: string): Promise<SpecificationStatus>;
}
